export default __webpack_public_path__ + "static/media/Group_894.a5d13200.svg";